const AccessDemand = () => {
  return (
    <div
      className="compare-item"
      style={{
        padding: "27px 8px",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        background: "#F5F9FD",
        justifyContent: "center",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div style={{ display: "flex" }}>
        <img
          src={
            (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
            "/blackCard.png"
          }
          alt="Vector"
          width={105}
          height={65}
        />
        <div
          style={{
            paddingLeft: 16,
            fontSize: 18,
            fontWeight: 500,
            color: "#212126",
          }}
        >
          ACCESS On- Demand Concierge Card
        </div>
      </div>
      <div style={{ display: "flex", paddingTop: 20 }}>
        <img
          src={
            (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
            "/giftcard.svg"
          }
          alt="giftcard"
          width={16}
          height={16}
        />
        <div style={{ fontSize: 18, color: "#212126", paddingLeft: 7 }}>
          Preloaded debit card
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "start", paddingTop: 10 }}>
        <img
          src={
            (process.env.REACT_APP_PUBLIC_ASSETS_URL ?? "/images") +
            "/people.svg"
          }
          alt="people"
          width={16}
          height={16}
          style={{ paddingTop: 5 }}
        />
        <div style={{ fontSize: 18, color: "#212126", paddingLeft: 7 }}>
          Live support 24 hours a day, 7 days a week
        </div>
      </div>
    </div>
  );
};

export default AccessDemand;
